import FacebookIcon from './FacebookIcon';

export default FacebookIcon;
